import React from 'react'
import styled from 'styled-components';
import { Tag } from './Tag'
import { Link } from 'gatsby';

const TagSlider = ({tags}) => {
  return (
    <Slider>
      {tags.map((tag, index) => (
        <StyledLink key={tag.label} to={tag.link} >
          <Tag>{tag.label}</Tag>
        </StyledLink>
      ))}
    </Slider>
  )
}

export default TagSlider
const maxMobileWidth = 768;

const StyledLink = styled(Link)`
  text-decoration: none;
  @media (max-width: ${maxMobileWidth}px) {
    &:first-child{
      margin-left:20px;
    }
  }
`;

const Slider = styled.div`
  overflow:visible;
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  width: 100vw;
  margin-bottom: 16px;
  margin-top: 16px;
  transition: transform 0.5s ease;
  @media (max-width: ${maxMobileWidth}px) {
    left: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
    overflow-x: scroll;
    position: relative;
    right: 50%;
    -ms-scroll-snap-type: x mandatory;
    scroll-snap-type: x mandatory;
    scrollbar-width: none;
  }
`;